var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00003 10.6276C7.40253 10.6276 6.09753 9.33008 6.09753 7.72508C6.09753 6.12008 7.40253 4.83008 9.00003 4.83008C10.5975 4.83008 11.9025 6.12758 11.9025 7.73258C11.9025 9.33758 10.5975 10.6276 9.00003 10.6276ZM9.00003 5.95508C8.02503 5.95508 7.22253 6.75008 7.22253 7.73258C7.22253 8.71508 8.01753 9.51008 9.00003 9.51008C9.98253 9.51008 10.7775 8.71508 10.7775 7.73258C10.7775 6.75008 9.97503 5.95508 9.00003 5.95508Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 17.07C7.89001 17.07 6.77251 16.65 5.90251 15.8175C3.69001 13.6875 1.24501 10.29 2.16751 6.2475C3.00001 2.58 6.20251 0.9375 9.00001 0.9375C9.00001 0.9375 9.00001 0.9375 9.00751 0.9375C11.805 0.9375 15.0075 2.58 15.84 6.255C16.755 10.2975 14.31 13.6875 12.0975 15.8175C11.2275 16.65 10.11 17.07 9.00001 17.07ZM9.00001 2.0625C6.81751 2.0625 4.01251 3.225 3.27001 6.495C2.46001 10.0275 4.68001 13.0725 6.69001 15C7.98751 16.2525 10.02 16.2525 11.3175 15C13.32 13.0725 15.54 10.0275 14.745 6.495C13.995 3.225 11.1825 2.0625 9.00001 2.0625Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.dd4fd9d0.svg";
export { ForwardRef as ReactComponent };